import { render, staticRenderFns } from "./ClientEditor.vue?vue&type=template&id=75c772f8"
import script from "./ClientEditor.vue?vue&type=script&lang=ts"
export * from "./ClientEditor.vue?vue&type=script&lang=ts"
import style0 from "./ClientEditor.vue?vue&type=style&index=0&id=75c772f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports